import React from 'react';

import './SliderDots.scss';

const SliderDots = ({ count, activeIndex }) => {
  if (!count || count === 1) return null;
  return (
    <div className="slider-dots">
      {Array.from(Array(count).keys()).map((_, i) => (
        <span className={`dot ${activeIndex === i ? 'dot-active' : ''}`} />
      ))}
    </div>
  );
};

export default SliderDots;
